module.exports = __webpack_public_path__ + "8f8bc72017cb4891dbea145f3572d1ef.webp";